import cls from 'classnames';
import * as React from 'react';

import { FieldProps, getIn } from 'formik';

const styles = require('./InputCheckbox.scss');

export interface Props extends FieldProps {
    label: string;
    readonly?: boolean;
    hideErrors?: boolean;
    disabled?: boolean;
}
export const MaterialCheckbox = ({
    field,
    form: { values, errors, touched },
    label,
    readonly,
    hideErrors,
    ...props
}: FieldProps & Props) => (
    <div className={cls({ [styles.disabled]: props.disabled })} style={readonly ? { pointerEvents: 'none' } : {}}>
        <div className='nx-checkbox nx-checkbox--small'>
            <label className={styles.label}>
                <input {...field} {...props} type='checkbox' className={styles.input} />
                {label}
            </label>
        </div>
        {!hideErrors && getIn(errors, field.name) && getIn(touched, field.name) && (
            <div className={styles.error}>{getIn(errors, field.name)}</div>
        )}
    </div>
);

export default MaterialCheckbox;
